import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import { Button } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import { useSelector } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import AdminSidebar from "../../layouts/AdminSidebar";
import { Trash, Plus } from "react-bootstrap-icons";
import { handleNumericInput } from "../../util/utils";
import ImageUploads from "../../util/ImageUploads";
import { authCall } from "../../../services";

function BookingPrizePage() {
  const [, forceUpdate] = useState();
  const validator = useRef(new SimpleReactValidator());
  const fieldsEndRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { current } = useSelector((state) => state.user);
  const [loadingSubs, setLoadingSubs] = useState("");
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [companies, setCompanaies] = useState([]);

  const initialField = {
    id: 1,
    company: "",
    activity: "",
    activityList: [],
    price: "",
    quantity: "",
    unlimited: false,
    onSide: 0,
    points: 0,
    bonousPoints: "",
    new: true,
    couponImage: "",
    isCouponImageChange: false,
  };

  const [bookingPrize, setBookingPrize] = useState([]);

  // Scroll into view when fields change
  // useEffect(() => {
  //   fieldsEndRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, [bookingPrize]);

  const getBookingPrize = async () => {
    setLoading(true);
    const resp = await authCall("getBookingPrize", {});
    const deals = [];
    if (resp?.type === "success") {
      resp?.payload.forEach(async (el, index) => {
        deals.push({
          id: index,
          bookingPrizeId: el.id,
          date: el.deal_date,
          company: el.company,
          activityId: el.activity_id,
          activity: el.activity,
          activityList: [],
          price: el.prize,
          quantity: el.quantity,
          claimed: el.claimed,
          unlimited: el.unlimited,
          onSide: el.on_side,
          couponImage: el.coupon_image,
          points: el.points,
          bonousPoints: el.coupon_value,
        });
      });
      setBookingPrize(deals);
      setLoading(false);
    }
  };

  const getCompanies = async () => {
    const resp = await authCall("getSearchList", {
      type: "booking",
    });
    if (resp?.type === "success") {
      setCompanaies(resp?.payload?.details);
    }
  };

  const getCompanyActivities = async (companyName) => {
    const resp = await authCall("getCompanyActivities", {
      companyName: companyName,
    });

    if (resp?.type === "success") {
      return resp?.payload?.details?.map((e) => ({
        ...e,
        label: e.activity_name,
      }));
    } else {
      return [];
    }
  };

  useEffect(() => {
    getBookingPrize();
    getCompanies();
  }, []);

  const addDeal = () => {
    const newFields = [];
    newFields.push({ ...initialField, id: bookingPrize.length + 1 });
    setBookingPrize([...bookingPrize, ...newFields]);
  };

  const handleChangePlan = (id, name, value) => {
    setBookingPrize(
      bookingPrize.map((field) =>
        field.id === id ? { ...field, [name]: value } : field
      )
    );
  };

  const handleChangeCheckbox = (id, e) => {
    const { name, checked, type } = e.target;
    if (type === "checkbox") {
      setBookingPrize(
        bookingPrize.map((field) =>
          field.id === id
            ? {
                ...field,
                onSide: 0,
                points: 0,
                [name]: checked ? 1 : 0,
                bonousPoints: "",
                company: "",
                activity: "",
                activityList: [],
              }
            : field
        )
      );
    } else {
      setBookingPrize(
        bookingPrize.map((field) =>
          field.id === id ? { ...field, [name]: checked } : field
        )
      );
    }
  };

  const handleChangeQuantity = (id, name, value) => {
    const inputValue = handleNumericInput(value);
    if (inputValue !== null && inputValue.length < 5) {
      setBookingPrize(
        bookingPrize.map((field) =>
          field.id === id ? { ...field, [name]: inputValue } : field
        )
      );
    }
  };

  const handleSubmit = async (item) => {
    if (validator.current.allValid()) {
      toast.dismiss();
      setLoadingSubs(`loading${item.id}`);
      const values = {
        userId: current.id,
        bookingPrizeId: item?.bookingPrizeId || "",
        company: item?.onSide ? item.company : null,
        activityId: item?.onSide ? item.activityId : null,
        activity: item?.onSide ? item.activity : null,
        price: item.price,
        quantity: item.quantity,
        unlimited: item.unlimited,
        onSide: item.onSide,
        points: item.points,
        couponValue: item?.bonousPoints || null,
        couponImage: item.isCouponImageChange ? item.couponImage : "",
      };
      const resp = await authCall("bookingPrize", values);
      if (resp?.type === "success") {
        setLoadingSubs("");
        toast.success(resp?.message);
      } else {
        setLoadingSubs("");
        toast.error(resp?.message);
      }
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const handleDelete = (el) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(el)}
          disabled={loadingDelete || false}
        >
          {loadingDelete ? "Loading..." : "Yes"}
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (el) => {
    if (el.bookingPrizeId) {
      const resp = await authCall("deleteBookingPrize", {
        bookingPrizeId: el.bookingPrizeId,
        isSoft: true,
      });
      setLoadingDelete(true);
      if (resp?.type === "success") {
        closeToast();
        toast.success(resp?.message);
        setLoadingDelete(false);
        getBookingPrize();
      } else {
        toast.error(resp?.message);
        setLoadingDelete(false);
      }
    } else {
      setBookingPrize(bookingPrize.filter((e) => e.id !== el.id));
      closeToast();
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  const handleChangeComapny = async (id, selected) => {
    const activitiesList = await getCompanyActivities(selected);
    setBookingPrize(
      bookingPrize.map((field) =>
        field.id === id
          ? {
              ...field,
              company: selected,
              activity: [],
              activitiesList: activitiesList,
            }
          : field
      )
    );
  };

  const handleChangeActivity = (id, selected) => {
    setBookingPrize(
      bookingPrize.map((field) =>
        field.id === id
          ? { ...field, activityId: selected.id, activity: selected }
          : field
      )
    );
  };

  const handleCouponImage = (id) => (img) => {
    setBookingPrize(
      bookingPrize.map((field) =>
        field.id === id
          ? { ...field, couponImage: img, isCouponImageChange: true }
          : field
      )
    );
  };

  return (
    <>
      {console.log("bookingPrize", bookingPrize)}
      <div className="restaurant-details-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-md-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">Booking Prize</div>

                {/* daily deals */}
                <div className="details-wrapper">
                  <div className="row">
                    <div className="col-12">
                      <div className="info-cover pb-lg-2">
                        <div
                          className="main-heading2 mb-3 mt-3"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Booking Prize:
                          {loading && (
                            <Skeleton count={1} height={31} width={120} />
                          )}
                          {!loading && (
                            <Button
                              className="btn btn-custom btn-custom-sm fs-16"
                              onClick={addDeal}
                            >
                              <Plus />
                              Add Prize
                            </Button>
                          )}
                        </div>
                        {loading && (
                          <div className="text-center mt-3">
                            Loading... Please wait
                          </div>
                        )}
                        {!loading &&
                          bookingPrize.map((field, index) => (
                            <div key={index}>
                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                {/* prize */}
                                <div className="col-4">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Prize
                                  </label>
                                  <input
                                    required
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={field.price}
                                    name="price"
                                    onChange={(e) =>
                                      handleChangePlan(
                                        field.id,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                  />
                                  {validator.current.message(
                                    "prize",
                                    field?.price,
                                    "required"
                                  )}
                                </div>

                                {/* quantity */}
                                <div className="col-3">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Quantity
                                  </label>
                                  <input
                                    required
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={field.quantity}
                                    name="quantity"
                                    onChange={(e) =>
                                      handleChangeQuantity(
                                        field.id,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                {/* remaining quantity */}
                                <div className="col-3">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Remaining
                                  </label>
                                  <input
                                    disabled
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={field?.quantity - field?.claimed}
                                    name="remainQuantity"
                                  />
                                </div>

                                {/* unlimited */}
                                <div className="col-2 d-flex flex-column">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Unlimited
                                  </label>
                                  <input
                                    type="checkbox"
                                    name="unlimited"
                                    id="mainEvent"
                                    checked={field.unlimited}
                                    onChange={(e) =>
                                      handleChangeCheckbox(field.id, e)
                                    }
                                  />
                                </div>
                              </div>

                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                <div className="col-1 d-flex flex-column">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    On Site
                                  </label>
                                  <input
                                    type="checkbox"
                                    name="onSide"
                                    id="mainEvent"
                                    checked={field.onSide}
                                    onChange={(e) =>
                                      handleChangeCheckbox(field.id, e)
                                    }
                                  />
                                </div>
                                <div className="col-1 d-flex flex-column">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Points
                                  </label>
                                  <input
                                    type="checkbox"
                                    name="points"
                                    id="mainEvent"
                                    checked={field.points}
                                    onChange={(e) =>
                                      handleChangeCheckbox(field.id, e)
                                    }
                                  />
                                </div>
                                {(field.points === 1 || field.onSide === 1) && (
                                  <div className="col-2">
                                    <div
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {field.points
                                        ? "Bonus Points"
                                        : "Discount (%)"}
                                    </div>
                                    <input
                                      required
                                      type="number"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.bonousPoints}
                                      name="bonousPoints"
                                      onChange={(e) =>
                                        handleChangeQuantity(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                    {(field.points === 1 ||
                                      field.onSide === 1) &&
                                      validator.current.message(
                                        field.points === 1
                                          ? "Bonus Points"
                                          : "Discount",
                                        field?.bonousPoints,
                                        "required"
                                      )}
                                  </div>
                                )}

                                {field?.onSide === 1 && (
                                  <>
                                    <div className="col-3">
                                      <label
                                        htmlFor="RestaurantPhone"
                                        className="fs-md-16 mb-1 text-custom-primary"
                                        style={{ fontWeight: 700 }}
                                      >
                                        Company
                                      </label>
                                      <Select
                                        className="text-body mt-1"
                                        placeholder="Select"
                                        value={
                                          field?.company
                                            ? companies.find(
                                                (c) =>
                                                  c.company_name ===
                                                  field?.company
                                              ) || null
                                            : null
                                        }
                                        onChange={(e) =>
                                          handleChangeComapny(
                                            field.id,
                                            e?.company_name
                                          )
                                        }
                                        options={companies}
                                      />
                                      {field.onSide === 1 &&
                                        validator.current.message(
                                          "Company",
                                          field?.company,
                                          "required"
                                        )}
                                    </div>
                                    <div className="col-3">
                                      <label
                                        htmlFor="RestaurantPhone"
                                        className="fs-md-16 mb-1 text-custom-primary"
                                        style={{ fontWeight: 700 }}
                                      >
                                        Activities
                                      </label>
                                      <Select
                                        className="text-body mt-1"
                                        placeholder="Select"
                                        value={field.activity}
                                        onChange={(e) =>
                                          handleChangeActivity(field.id, e)
                                        }
                                        options={field?.activitiesList}
                                      />
                                      {field.onSide === 1 &&
                                        validator.current.message(
                                          "Activities",
                                          field?.activity,
                                          "required"
                                        )}
                                    </div>
                                  </>
                                )}
                                <div
                                  className={`${
                                    field.points ? "col-lg-3" : "col-lg-2"
                                  }`}
                                >
                                  <div className="info-cover">
                                    <div className="profile-cover">
                                      <label
                                        htmlFor="RestaurantPhone"
                                        className="fs-md-16 mb-2 text-custom-primary"
                                        style={{ fontWeight: 700 }}
                                      >
                                        Coupon Image
                                      </label>
                                      <ImageUploads
                                        getImage={handleCouponImage(field.id)}
                                        uploadedImage={
                                          field?.couponImage
                                            ? field?.couponImage
                                            : ""
                                        }
                                        index="2"
                                        aspectRation={1}
                                        croppedSize={{
                                          width: 870,
                                          height: 580,
                                          imageSmoothingQuality: "high",
                                        }}
                                      />
                                      <div
                                        style={{
                                          marginTop: !field?.couponImage
                                            ? "-5px"
                                            : 0,
                                        }}
                                      >
                                        {validator.current.message(
                                          "coupon image",
                                          field?.couponImage,
                                          "required"
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3 mt-4">
                                <div className="col-4"></div>
                                <div className="col-4">
                                  <div className="d-flex align-items-center">
                                    <button
                                      type="button"
                                      style={{
                                        height: 40,
                                        width: "50%",
                                        zIndex: 0,
                                      }}
                                      className="btn btn-custom btn-custom-sm fs-16"
                                      onClick={() => handleSubmit(field)}
                                      disabled={
                                        `loading${field?.id}` === loadingSubs ||
                                        false
                                      }
                                    >
                                      {`loading${field?.id}` === loadingSubs
                                        ? "Loading..."
                                        : field.new
                                        ? `Submit`
                                        : "Update"}
                                    </button>
                                    {bookingPrize.length > 1 && (
                                      <Trash
                                        onClick={() => handleDelete(field)}
                                        className="cursor-pointer"
                                        style={{
                                          marginLeft: 10,
                                          color: "red",
                                          width: 25,
                                          height: 25,
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                        {/* This is the scroll target */}
                        <div ref={fieldsEndRef} />
                        {!loading && bookingPrize.length === 0 && (
                          <div className="text-center mt-3">
                            No deals available
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BookingPrizePage;
